<template>
	<div class="watch-biometric-alert-view-response">
		<div v-if="!reports.loading && reports.showForm">
			<h1>{{ $t('headers.general.report') }}</h1>
			<form @submit.prevent="validateAndSubmit">
				<input-textarea v-model="model.report" name="report_report" :placeholder="$t('labels.general.report')" rules="required"/>
				<input-radio v-model="model.status" :options="options" name="report_status" :placeholder="$t('labels.general.status')" rules="required"/>
				<div class="form-group-actions">
					<button-submit-icon-text :loading="form.loading" icon="check">{{ $t('buttons.general.submit') }}</button-submit-icon-text>
				</div>
			</form>
		</div>
		<h1>{{ $t('headers.general.reports') }}</h1>
		<spinner v-if="reports.loading"/>
		<div v-if="!reports.loading && reports.data.length" class="idi-table reports">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell">{{ $t('labels.general.hour') }}</div>
				<div class="idi-cell">{{ $t('labels.general.person') }}</div>
				<div class="idi-cell">{{ $t('labels.general.status') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="report in reports.data" :key="report.id">
				<div class="idi-cell">{{ date(report.date) }}</div>
				<div class="idi-cell">{{ report.date | formatTime(vue) }}</div>
				<div class="idi-cell">{{ report.user.fullname }}</div>
				<div class="idi-cell">{{ status(report.status) }}</div>
				<div class="idi-cell">
					<button @click="onViewReportClick(report)" class="btn btn-small btn-round btn-primary">{{ $t('buttons.actions.view_report') }}</button>
				</div>
			</div>
		</div>
		<div v-if="!reports.loading && !reports.data.length">{{ $t('labels.general.no_reports') }}</div>
		<modal-box v-if="selected" @close="onModalBoxClose">
			<span slot="header">{{ $t('headers.general.report') }}</span>
			{{ selected.report }}
		</modal-box>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import FormObject from '@/classes/api/FormObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'alert_id'
	],
	data () {
		return {
			componentName: 'watch biometric alert history view response',
			vue: this,
			model: {
				report: '',
				status: ''
			},
			form: new FormObject(),
			reports: {
				loading: false,
				error: null,
				data: [],
				showForm: true
			},
			// STATUS_UNKNOWN = 0; STATUS_IN_PROGRESS = 1; STATUS_DONE = 2; STATUS_CANCEL = 4;
			options: [
				{ text: 'In progress', value: 1 },
				{ text: 'Done', value: 2 },
				{ text: 'Cancel', value: 4 }
			],
			selected: null
		}
	},
	computed: {
		user () {
			return this.$store.getters.getUser
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.addReport()
				})
		},
		date (date) {
			return this.$moment(date).format('DD MMM YYYY')
		},
		status (status) {
			switch (parseInt(status)) {
				case 1:
					return 'In progress'
				case 2:
					return 'Done'
				case 4:
					return 'Cancel'
				default:
					return 'Unknown'
			}
		},
		getReports () {
			this.reports.loading = true
			this.$api.alerts.getReports(this, this.user_uid, this.watch_id, this.type_id, this.alert_id)
				.then(response => {
					this.$log.info(this.componentName, 'alerts.getReports OK', response)()
					this.reports.data = response.body
					this.reports.showForm = this.reports.data.reduce((result, current) => {
						return result && (parseInt(current.status) === 1)
					}, true)
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.getReports ERROR', error)()
					this.reports.error = error
				}).finally(() => {
					this.reports.loading = false
				})
		},
		addReport () {
			const model = {
				user_uid: this.user.uid,
				status: this.model.status,
				report: this.model.report
			}
			this.form.loading = true
			this.$api.alerts.addReport(this, this.user_uid, this.watch_id, this.type_id, this.alert_id, model)
				.then(response => {
					this.$log.info(this.componentName, 'alerts.addReport OK', response)()
					this.model = {
						report: '',
						status: ''
					}
					this.getReports()
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.addReport ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		onViewReportClick (report) {
			this.selected = report
		},
		onModalBoxClose () {
			this.selected = null
		}
	},
	mounted () {
		this.getReports()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alertsV2/ReadingsAlertViewResponse.vue